import React, { FC, useContext, useState } from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';

// context
import { EditorContext } from '../../context/EditorContext';

// components
import FormulaViewer from '../../editors/FormulaViewer/FormulaViewer';

import useApprovedFormulaQueryV1 from 'hooks/formulas/useApprovedFormulaQueryV1';

// models
import {
    FormulaApproveModelV1,
    FormulaStatus,
    MaxCharacterModel,
} from '../../models/formula.model';

import SidebarViewMain, { ToggleButtonValues } from './SidebarViewMain';

interface FormulaEditorViewProps {
    data: FormulaApproveModelV1;
    maxCharacterCounts: MaxCharacterModel;
    className?: string;
    isEditable: boolean;
    hideToggleButtons?: boolean;
}

const FormulaEditorView: FC<React.PropsWithChildren<FormulaEditorViewProps>> =
    ({
        data,
        maxCharacterCounts,
        className,
        isEditable,
        hideToggleButtons,
    }) => {
        const [selectedComponent, setSelectedComponent] = useState<Record<
            string,
            any
        > | null>(null);

        const [isVariationTabOpened, setIsVariationTabOpened] = useState(
            ToggleButtonValues.PREVIEW,
        );

        const {
            editorDetails: { formula },
        } = useContext(EditorContext);
        const { isPending: isLoading } = useApprovedFormulaQueryV1(
            parseInt(formula?.id as any),
        );
        const handleVariantSelect = (item: Record<string, any> | null) => {
            setSelectedComponent(item);
            setIsVariationTabOpened(ToggleButtonValues.VIEW_VARIATION);
        };

        return (
            <Container className={className}>
                <FormulaEditorWithCMSSettings>
                    <StyledFormulaViewer
                        formula={data}
                        isEditable={isEditable}
                        handleSelection={handleVariantSelect}
                        selectedComponent={selectedComponent}
                        maxCharacterCounts={maxCharacterCounts}
                        isReadOnly={data.active_state === FormulaStatus.Review}
                    />
                </FormulaEditorWithCMSSettings>
                {!isLoading && (
                    <SidebarViewMain
                        isVariationTab={isVariationTabOpened}
                        setIsVariationTab={setIsVariationTabOpened}
                        selectedElement={selectedComponent}
                        components={data.components ?? []}
                        hideToggleButtons={hideToggleButtons}
                    />
                )}
            </Container>
        );
    };

const Container = styled.div(() => ({
    padding: aampeTheme.spacing(4),
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: '750px',
    marginBottom: aampeTheme.spacing(3),
}));

const FormulaEditorWithCMSSettings = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing(4),
    width: '50%',
});

const StyledFormulaViewer = styled(FormulaViewer)({
    width: '85%',
});

export default FormulaEditorView;
